import { defineStore } from 'pinia'

// initial state
const state = () => ({
  currentTippyGroup: null,
  enableOverlay: false,
  tippyGroups: [],
})

// functionName: (state, getters, rootState) => {}
const getters = {}

// functionName ({ commit, state, dispatch }, param, ...) {}
const actions = {
  addTippyGroup(groupId, itemIndex) {
    const existingGroup = this.tippyGroups.find(tippyGroup => tippyGroup.id === groupId)
    if (!existingGroup) {
      this.tippyGroups.push({
        id: groupId,
        currentItem: 0,
        items: [itemIndex],
        maxItems: 0
      })
    } else {
      existingGroup.items.push(itemIndex)
      existingGroup.maxItems++
    }
  },
  removeTippyGroup(groupId) {
    const newArr = this.tippyGroups.filter(object => object.id !== groupId)
    this.tippyGroups = newArr
  },
  resetCurrentTippyGroup() {
    this.currentTippyGroup.currentItem = 0
    this.currentTippyGroup = null
    this.enableOverlay = false
  },
  setCurrentTippyGroup(groupId, enableOverlay = false) {
    this.currentTippyGroup = this.tippyGroups.find(tippyGroup => tippyGroup.id === groupId)
    this.enableOverlay = enableOverlay
  }
}

export default defineStore({
  id: 'tippyGuide',
  state,
  getters,
  actions
})
